import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

const topics: TopicItem[] = [
  {
    id: 'introduction',
    title: 'Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'What is Node.js?', completed: true },
      { id: 'intro-2', title: 'Node.js vs Browser JavaScript', completed: false },
      { id: 'intro-3', title: 'Installing Node.js', completed: false },
    ],
  },
  {
    id: 'fundamentals',
    title: 'Fundamentals',
    completed: false,
    children: [
      { id: 'modules', title: 'Modules & require()', completed: false },
      { id: 'npm', title: 'NPM & Package Management', completed: false },
      { id: 'file-system', title: 'File System (fs)', completed: false },
      { id: 'path-module', title: 'Path Module', completed: false },
      { id: 'events', title: 'Events & EventEmitter', completed: false },
    ],
  },
  {
    id: 'http-server',
    title: 'HTTP Server',
    completed: false,
    children: [
      { id: 'http-basics', title: 'HTTP Basics', completed: false },
      { id: 'express-intro', title: 'Introduction to Express', completed: false },
      { id: 'routing', title: 'Routing', completed: false },
      { id: 'middleware', title: 'Middleware', completed: false },
      { id: 'error-handling', title: 'Error Handling', completed: false },
    ],
  },
  {
    id: 'async-programming',
    title: 'Async Programming',
    completed: false,
    children: [
      { id: 'callbacks', title: 'Callbacks', completed: false },
      { id: 'promises-node', title: 'Promises', completed: false },
      { id: 'async-await-node', title: 'Async/Await', completed: false },
      { id: 'streams', title: 'Streams', completed: false },
    ],
  },
  {
    id: 'database-integration',
    title: 'Database Integration',
    completed: false,
    children: [
      { id: 'mongodb', title: 'MongoDB with Mongoose', completed: false },
      { id: 'postgresql', title: 'PostgreSQL', completed: false },
      { id: 'redis', title: 'Redis', completed: false },
    ],
  },
];

const NodeJSPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="nodejs"
      topics={topics}
      title="Master Node.js"
    />
  );
};

export default NodeJSPractice;
